"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var equipment_service_1 = require("../../../shared/service/equipment.service");
var attending_1 = require("../../model/attending");
var configuration_1 = require("../../model/configuration");
var sim_card_service_1 = require("../../../shared/service/sim-card.service");
var sim_card_1 = require("../../../shared/model/sim-card");
var access_1 = require("../../../shared/model/access");
var authentication_service_1 = require("../../../shared/service/authentication.service");
var screening_service_1 = require("../../service/screening.service");
var configuration_types_1 = require("../../model/configuration-types");
var jira_ticket_service_1 = require("../../../appraisal/service/jira-ticket.service");
var ConfigurationComponent = /** @class */ (function () {
    function ConfigurationComponent(_equipmentService, _simCardService, _authService, _screeningService, _jiraTicketService) {
        this._equipmentService = _equipmentService;
        this._simCardService = _simCardService;
        this._authService = _authService;
        this._screeningService = _screeningService;
        this._jiraTicketService = _jiraTicketService;
        this._attending = new attending_1.Attending();
        this.txOnSave = new core_1.EventEmitter();
        this.txOnCancel = new core_1.EventEmitter();
        this.equipmentAttributesTree = ['serial'];
        this.simCardAttributesTree = ['iccid'];
        this.equipments = new Array();
        this.simCards = new Array();
        this.CONFIGURATION = 'CONFIGURATION';
        this.EQUIPMENT_AVAILABLE_STATUS = 'CONFIGURACAO';
        this.setUpObservers();
        this._screeningService.findConfigurationTypes();
    }
    ConfigurationComponent.prototype.ngOnInit = function () {
    };
    ConfigurationComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    Object.defineProperty(ConfigurationComponent.prototype, "attending", {
        get: function () {
            return this._attending;
        },
        set: function (attending) {
            this._attending = attending;
            this.setEmptyEntities();
            this.showStep();
            if (this.canEdit()) {
                this._jiraTicketService.findJiraTicket(attending.jiraTicket);
            }
        },
        enumerable: true,
        configurable: true
    });
    ConfigurationComponent.prototype.save = function () {
        this.txOnSave.emit(this.attending);
    };
    ConfigurationComponent.prototype.cancel = function () {
        this.txOnCancel.emit();
    };
    ConfigurationComponent.prototype.findEquipmentBySerialAndStatus = function (serial) {
        this._equipmentService.findBySerialAndStatus(serial, this.EQUIPMENT_AVAILABLE_STATUS);
    };
    ConfigurationComponent.prototype.findByIccid = function (iccid) {
        this._simCardService.findAvailableSimCardsWithAccessByIccidContains(iccid);
    };
    ConfigurationComponent.prototype.setEquipment = function (equipment) {
        this.attending.attendingEquipmentInfo.equipmentChosenForAttending = equipment;
        this.attending.configuration.equipmentModel = equipment.equipmentModel;
        this.attending.configuration.simCard = equipment.simCard;
    };
    ConfigurationComponent.prototype.canEdit = function () {
        return (this.attending.configuration.canEdit || this.attending.configuration.canEdit === undefined) && this.editable;
    };
    ConfigurationComponent.prototype.canView = function () {
        return this.attending.configuration.canView && !this.canEdit();
    };
    ConfigurationComponent.prototype.showStep = function () {
        if (this.attending.orderedSteps && this.attending.currentStep === this.CONFIGURATION) {
            this.setIsVisible();
            this.setIsEditable();
        }
    };
    ConfigurationComponent.prototype.resolveJiraTicketResult = function (jiraTicket) {
        this.resolveJiraTickeTOS(jiraTicket);
    };
    ConfigurationComponent.prototype.resolveJiraTickeTOS = function (jiraTicket) {
        if (jiraTicket.os) {
            this.attending.serviceOrder = jiraTicket.os;
        }
    };
    ConfigurationComponent.prototype.setIsVisible = function () {
        var _this = this;
        if (this.attending.orderedSteps.includes(this.CONFIGURATION)
            && this.authenticatedUser.stepViews.find(function (view) { return view.stepViewType === _this.CONFIGURATION; })) {
            this.attending.configuration.canView = true;
        }
        else {
            this.attending.configuration.canView = false;
        }
    };
    ConfigurationComponent.prototype.setIsEditable = function () {
        var _this = this;
        if (this.authenticatedUser.stepKeys.find(function (view) { return view.stepType === _this.CONFIGURATION; })) {
            this.attending.configuration.canEdit = true;
        }
        else {
            this.attending.configuration.canEdit = false;
        }
    };
    ConfigurationComponent.prototype.setUpObservers = function () {
        var _this = this;
        this._jiraTicketService.find$
            .subscribe(function (jiraTicket) { return _this.resolveJiraTicketResult(jiraTicket); });
        this._equipmentService.find$
            .subscribe(function (equipments) { return _this.equipments = equipments; });
        this._simCardService.find$
            .subscribe(function (simCards) { return _this.simCards = simCards; });
        this._screeningService.find$
            .filter(function (result) { return result instanceof configuration_types_1.ConfigurationTypes; })
            .subscribe(function (configurationTypes) {
            _this.configurationTypes = configurationTypes;
        });
    };
    ConfigurationComponent.prototype.setEmptyEntities = function () {
        this.authenticatedUser = this._authService.getUserFromLocalStorage();
        if (!this.attending.configuration) {
            this.attending.configuration = new configuration_1.Configuration();
        }
        if (!this.attending.configuration.simCard) {
            this.attending.configuration.simCard = new sim_card_1.SimCard();
            this.attending.configuration.simCard.access = new access_1.Access();
        }
    };
    ConfigurationComponent.ctorParameters = function () { return [{ type: equipment_service_1.EquipmentService }, { type: sim_card_service_1.SimCardService }, { type: authentication_service_1.AuthenticationService }, { type: screening_service_1.ScreeningService }, { type: jira_ticket_service_1.JiraTicketService }]; };
    return ConfigurationComponent;
}());
exports.ConfigurationComponent = ConfigurationComponent;
//# sourceMappingURL=configuration.component.js.map


// WEBPACK FOOTER //
// configuration.component.js